import { API_endpoints } from "../config";
import { ProcessBookingValues } from "modules/booking";

export const processBooking = async (formDate: ProcessBookingValues) => {
    try {
        const response = await fetch(API_endpoints.processBooking, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(formDate),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim bearbeitung von Booking.");
        }
        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Fehler beim bearbeitung von Booking:", error);
        throw error;
    }
};
